import React from 'react';
import Link from 'gatsby-link';
import { Row, Col, Card, CardImg, CardTitle, CardText, CardBody, Container } from 'reactstrap';
import CodeImg from './code.jpg';
import mountingImg from './wintersense-csl-mounting.jpg';
import FovVisualiser from './fov_visualiser.png';

const DocsListing = () => (
  <div>

    <Container>

      <Row>

        <Col sm="12" lg="6">
          <Card className="my-2">
            <CardImg top width="100%" src={CodeImg} alt="Code"/>
            <CardBody>
              <CardTitle>How to use the API</CardTitle>
              <CardText>The Wintersense API provides numerous HTTPS endpoints for accessing data collected by your Networks. This is great way to pull data into your own application.</CardText>
              <a href="https://docs.wintersense.com/api/v1" className="btn btn-primary">API Docs</a>
            </CardBody>          
          </Card>
        </Col>

        <Col sm="12" lg="6">
          <Card className="my-2">
            <CardImg top width="100%" src={mountingImg} alt="Wintersense Mounting"/>
            <CardBody>
              <CardTitle>Installing a Sensor</CardTitle>
              <CardText>Need to know where and how to install a Wintersense Road Temperature sensor? Our guide explains all.</CardText>
              <Link to="/installation" className="btn btn-primary">Installation Guide</Link>
            </CardBody>          
          </Card>                
        </Col>

        <Col sm="12" lg="6">
          <Card className="my-2">
            <CardImg top width="100%" src={FovVisualiser} alt="Field of View Visualiser"/>
            <CardBody>
              <CardTitle>Field of View Visualiser</CardTitle>
              <CardText>Assess if a site is suitable for a Wintersense sensor using this interactive tool.</CardText>
              <Link to="/field-of-view" className="btn btn-primary">Try it out</Link>
            </CardBody>          
          </Card>                
        </Col>  

        <Col sm="12" lg="6">
        </Col>        

      </Row>  

    </Container>

  </div>
);

export default DocsListing;



// WEBPACK FOOTER //
// ./src/components/DocsListing/index.js